class HbQuickAdd extends HTMLElement {
  constructor() {
    super();

    this.incrementBtnSelector = '[js-quantity-increment]';
    this.decrementBtnSelector = '[js-quantity-decrement]';

    this.wrapper = this.querySelector('[js-hb-quick-add-wrapper]');
    this.init();
    this.close();
  }

  init() {
    document.addEventListener('click', (e) => {
      document.querySelectorAll('[js-hb-quick-add-btn]').forEach((btn) => {
        if (btn.contains(e.target)) {
          btn.querySelector(".loading__spinner")?.classList.remove("hidden");
          this.wrapper.innerHTML = '';
          const productHandle = btn.getAttribute('data-product-handle');
          this.render(productHandle, btn);
        }
      });
    });
  }

  close() {
    this.querySelectorAll('[js-hb-quick-add-modal-close-btn]').forEach((btn) => {
      btn.addEventListener('click', () => {
        this.classList.remove('open');
        this.wrapper.classList.remove("is-animate");
      });
    });
  }

  render(handle, btn) {
    const url = `${location.origin}/products/${handle}?section_id=hb-quick-add-ajax`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

        this.wrapper.insertAdjacentElement('afterbegin', responseHTML.querySelector('[js-hb-quick-add-content]'));

        btn.querySelector(".loading__spinner")?.classList.add("hidden");
        this.classList.add('open');
        setTimeout(() => {
          this.wrapper.classList.add("is-animate");
        }, 100)

        this.close();
        this.quickAdd();

        // Handle increment button
        this.querySelectorAll(this.incrementBtnSelector).forEach((incrementBtn) => {
          incrementBtn.addEventListener('click', () => {
            this.updateVariant();
          });
        });

        // Handle decrement button
        this.querySelectorAll(this.decrementBtnSelector).forEach((decrementBtn) => {
          decrementBtn.addEventListener('click', () => {
        
            const quantityInput = decrementBtn.closest('quick-quantity-input').querySelector('input');
            if (quantityInput.value * 1 < 1) {
              const btnParentEle = decrementBtn.closest('[js-quick-add-wrap]');
              const qtyBtnWrapper = btnParentEle.querySelector('[js-quick-add-qty]');
              btnParentEle.querySelector('[js-quick-add-btn]').classList.remove('hidden');
              qtyBtnWrapper.classList.add('hidden');
              quantityInput.setAttribute('disabled', '')

              const variantId = quantityInput.getAttribute('data-variant-id')
              document.querySelector(`[js-product-variant-input][value="${variantId}"]`).setAttribute('disabled', '')

            }
            this.updateVariant();
          });
        });

      });
  }

 async addToCart() {
    const cartItems = [];

    this.querySelectorAll('[js-variant-content-wrap]').forEach((variantParent) => {
      const quantityInput = variantParent.querySelector('quantity-input input');
      const quantityInputWrap = variantParent.querySelector('quantity-input');
      const quantity = parseInt(quantityInput.value);
      if (quantity > 0 && !quantityInputWrap.classList.contains('hidden')) {
        const variantId = variantParent.getAttribute('data-variant-id');
        cartItems.push({ id: variantId, quantity });
      }
    });

    if (cartItems.length > 0) {
      const cartDrawer = document.querySelector('cart-drawer');
      if(cartDrawer){
        requestBody.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
        try {
          const resp = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            body: JSON.stringify(requestBody),
            headers: {
              "Content-Type": "application/json",
            },
          });
          const data = await resp.json();

          cartDrawer.renderContents(data);
          // document.querySelector('cart-drawer').open();
      
        } catch(err){
          console.log({ err })
        }
      }
    } else {
      alert('No items to add to the cart');
    }
  }

  quickAdd() {
    this.querySelectorAll('[js-quick-add-btn]').forEach((quickAddBtn) => {
      quickAddBtn.addEventListener('click', () => {
        quickAddBtn.classList.add('hidden');
        const btnParentEle = quickAddBtn.closest('[js-quick-add-wrap]');
        const qtyBtnWrapper = btnParentEle.querySelector('[js-quick-add-qty]');
        qtyBtnWrapper.classList.remove('hidden');

        btnParentEle.querySelector('[data-cart-quantity]').removeAttribute('disabled')
        btnParentEle.querySelector('[data-cart-quantity]').value = 1;
        const variantId = btnParentEle.querySelector('[data-cart-quantity]').getAttribute('data-variant-id')
        document.querySelector(`[js-product-variant-input][value="${variantId}"]`).removeAttribute('disabled')
        
        this.updateVariant();
      });
    });
  }

  updateVariant() {
    let totalPrice = 0;
    let noVariantAdded = true;
    const variantParents = this.querySelectorAll('[js-variant-content-wrap]');

    variantParents.forEach((variantParent) => {
        const quantityInput = variantParent.querySelector('quick-quantity-input');
        if (quantityInput && !quantityInput.classList.contains('hidden')) {
            const productLinePrice = parseInt(variantParent.getAttribute('data-variant-price'));
            const quantities = parseInt(quantityInput.querySelector('input').value) || 0;
            
            if (quantities > 0) {
                totalPrice += productLinePrice * quantities;
                noVariantAdded = false;
            }
        }
  
    });

    this.updatePrice(totalPrice);
    this.toggleAddToCartBtn(noVariantAdded);

  }

  toggleAddToCartBtn(check) {

    const parent = this.querySelector('[js-hb-quick-add-wrapper]');
    const addToCartBtn = parent.querySelector('[js-atc-btn]');
    const addToCartBtnEmpty = parent.querySelector('[js-atc-empty]');
    if (check) {
      addToCartBtnEmpty.classList.remove('hidden');
      addToCartBtn.classList.add('hidden');
    } else {
      addToCartBtn.classList.remove('hidden');
      addToCartBtnEmpty.classList.add('hidden');
    }
  }

  updatePrice(totalPrice) {
    const atcBtnTotalPrice = this.querySelector('[js-hb_total-price]');
    atcBtnTotalPrice.textContent = `₹${totalPrice}`;
  }
}

customElements.define('hb-quick-add', HbQuickAdd);



class QuickQuantityInput extends QuantityInput {
  constructor(){
    super()
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);

    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }

}

customElements.define('quick-quantity-input', QuickQuantityInput);

